import { Flavor, Primary } from "../../Flavor";

interface ButtonProps {
  label: string;
  onClick?: () => void;
  flavor?: Flavor;
  disabled?: boolean;
  className?: string;
}

export const Button = (props: ButtonProps) => {
  const flavor: Flavor = props.flavor ?? Primary;

  if (props.disabled)
    return (
      <button
        className={`${flavor.main} text-white font-bold py-2 px-4 rounded ${props.className}`}
        disabled
      >
        {props.label}
      </button>
    );

  return (
    <button
      className={`${flavor.main} ${flavor.hover} text-white font-bold py-2 px-4 rounded ${props.className}`}
      onClick={props.onClick}
    >
      {props.label}
    </button>
  );
};
